module.exports = __webpack_public_path__ + "static/img/user.290a3fff6d.png";